<template>
  <div class="t-map">
    <el-dialog title="选择地址" :visible.sync="showtmap" width="800px" append-to-body :before-close="handelclose">
      <el-row>
        <el-form label-width="40px" :inline="true" size="mini">
          <el-form-item label="搜索">
            <el-autocomplete v-model="keyword" value-key="title" placeholder="请输入地址搜索" clearable :fetch-suggestions="querySearch" @select="checkaddress"></el-autocomplete>
          </el-form-item>
          <el-form-item label="经度">
            <span class="text">{{ location.lat }}</span>
          </el-form-item>
          <el-form-item label="纬度">
            <span class="text">{{ location.lng }}</span>
          </el-form-item>
          <el-form-item label="地址">
            <span class="text">{{ location.address }}</span>
          </el-form-item>
        </el-form>
      </el-row>
      <div id="map"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="close">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qq from "qq";
export default {
  name: "TencentMap",
  computed: {
    showtmap() {
      var val = this.$store.getters.getshowtmap;
      if (val) {
        this.$nextTick(function() {
          this.init();
        });
      }
      return val;
    }
  },
  props: {
    lat: {
      type: Number,
      default: 39.916527
    },
    lng: {
      type: Number,
      default: 116.397128
    }
  },
  data() {
    return {
      keyword: "",
      map: {},
      key: "BUGBZ-NR4KP-2AFDK-LJLEB-W2LVV-S5FGH",
      marker: "",
      location: {
        lat: "",
        lng: "",
        city: "",
        address: "",
        district: ""
      }
    };
  },
  methods: {
    init() {
      let that = this;
      var map;
      //步骤：定义map变量 调用 qq.maps.Map() 构造函数   获取地图显示容器
      //设置地图中心点
      var myLatlng = new qq.maps.LatLng(this.location.lat, this.location.lng);
      //定义工厂模式函数
      var myOptions = {
        zoom: 15, //设置地图缩放级别
        center: myLatlng, //设置中心点样式
        mapTypeId: qq.maps.MapTypeId.ROADMAP //设置地图样式详情参见MapType
      };
      //获取dom元素添加地图信息
      this.map = map = new qq.maps.Map(document.getElementById("map"), myOptions);
      this.marker = new qq.maps.Marker({ position: myLatlng, map: map });
      //给地图添加点击事件
      //并获取鼠标点击的经纬度
      qq.maps.event.addListener(this.map, "click", function(event) {
        that.getmapgeocoder(event.latLng.lat, event.latLng.lng);
      });
    },
    getmapgeocoder(lat, lng) {
      var params = {
        location: lat + "," + lng,
        key: this.key
      };
      this.$api.mapgeocoder(params).then((data) => {
        let { message, result } = data;
        if (message != "query ok") {
          this.$message.error(message);
          return;
        }
        var obj = {
          address: result.formatted_addresses.recommend,
          city: result.address_component.city,
          district: result.address_component.district,
          lat: result.location.lat,
          lng: result.location.lng
        };
        this.location = obj;
        var myLatlng = new qq.maps.LatLng(this.location.lat, this.location.lng);
        this.marker = new qq.maps.Marker({ position: myLatlng, map: this.map });
      });
    },
    close() {
      this.$store.commit("setshowtmap", false);
    },
    confirm() {
      this.$emit("getlocation", this.location);
      this.$store.commit("setshowtmap", false);
    },
    handelclose() {
      this.$emit("getlocation", this.location);
      this.$store.commit("setshowtmap", false);
    },
    checkaddress(e) {
      var obj = {
        address: e.address,
        city: e.city,
        district: e.district,
        lat: e.location.lat,
        lng: e.location.lng
      };
      this.location = obj;
      this.map.setCenter(new qq.maps.LatLng(this.location.lat, this.location.lng));
      var myLatlng = new qq.maps.LatLng(this.location.lat, this.location.lng);
      this.marker = new qq.maps.Marker({ position: myLatlng, map: this.map });
    },
    querySearch(queryString, cb) {
      if (queryString.length == 0) return;
      var params = {
        region: "武汉",
        keyword: queryString
      };
      this.$api.placesuggestion(params).then((data) => {
        if (data.message != "query ok") {
          this.$message.error(data.message);
          return;
        }
        cb(data.data);
      });
    }
  },
  watch: {
    lat(newValue) {
      this.location.lat = newValue;
    },
    lng(newValue) {
      this.location.lng = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
#map {
  width: 760px;
  height: 500px;
}
</style>
